// extracted by mini-css-extract-plugin
export default {"laptopMenu":"navbar_laptopMenu__TGJmT","manuchild":"navbar_manuchild__vR+Pc"};